import { ReactNodeViewRenderer } from '@tiptap/react'

import {
  VariableNode as SharedVariableNode,
  VariableNodeAttributes,
} from '~shared/richtext/nodes/variable.node'

import { getVariableFromCache } from '@/entities/variables/api/hooks'

import { VariableNodeViewLive } from './VariableNodeView'
import { createVariablesSuggestion } from './VariablesSuggestions'

/**
 * Extends our custom `VariableNode` with client-only features.
 */
export const VariableNode = SharedVariableNode.extend({
  renderText({ node }) {
    const attrs = node.attrs as VariableNodeAttributes

    const variable = getVariableFromCache(attrs.variableKey)

    const currentValue = variable?.value
    const fallbackValue = attrs.fallbackValue ?? 'unknown'

    return `$${currentValue ?? fallbackValue}`
  },

  addNodeView() {
    return ReactNodeViewRenderer(VariableNodeViewLive)
  },

  addProseMirrorPlugins(this) {
    return [
      createVariablesSuggestion({
        name: this.name,
        editor: this.editor,
      }),
    ]
  },
})
